var version = '1.12.0';
export default version;
